import { render, staticRenderFns } from "./superUserPage.vue?vue&type=template&id=09964f81&scoped=true"
import script from "./superUserPage.vue?vue&type=script&lang=js"
export * from "./superUserPage.vue?vue&type=script&lang=js"
import style0 from "./superUserPage.vue?vue&type=style&index=0&id=09964f81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09964f81",
  null
  
)

export default component.exports